<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import ConfirmationModal from '@/components/confirmationModal';
import { toast, variants } from "@/helpers/toaster";

export default {
  page: {
    title: "Porudžbenice",
  },
  components: {PageHeader, Layout, ConfirmationModal},
  props: {
  },
  data() {
    return {
      title: 'Porudžbenice',
      currentPage: 1,
      perPage: 15,
      sortBy: 'client.status',
      sortDesc: true,
      search: '',
      statuses: [
        { key: 'ALLOW_ORDERING', value: 'Aktivan' },
        { key: 'DISALLOW_ORDERING', value: 'Neaktivan' },
        { key: 'SOFT_ORDERED', value: 'Poslato' }
      ],
      status: '',
      initialFields: [
        {key: 'id', label: 'Id', sortable: false},
        {key: 'sifra', label: 'Šifra', sortable: false},
        {key: 'pak', label: 'Pak', sortable: false},
        {key: 'jm', label: 'JM', sortable: false},
        {key: 'naziv_artikla2', label: 'Naziv Artikla', sortable: false},
        {key: 'cena', label: 'Cena', sortable: false},
        {key: 'rabat', label: 'Rabat', sortable: false},
        {key: 'cena_sa_rabatom', label: 'Cena sa Rabatom', sortable: false},
      ],
      fields: [
        {key: 'id', label: 'Id', sortable: false},
        {key: 'sifra', label: 'Šifra', sortable: false},
        {key: 'pak', label: 'Pak', sortable: false},
        {key: 'naziv_artikla2', label: 'Naziv Artikla', sortable: false},
        {key: 'cena', label: 'Cena', sortable: false},
        {key: 'rabat', label: 'Rabat', sortable: false},
        {key: 'cena_sa_rabatom', label: 'Cena sa Rabatom', sortable: false},
      ],
      orderFormItems: [],
      note: '',
      debounceTimer: null, // Timer for debouncing
      orderFormId: null,
      groups: [],
      showOrdered: true,
      selectedGroup: null,
      deadline: {
        value: '',
        error: false,
      },
    }
  },
  watch: {
    showOrdered(v) {
      this.search = '';
    },
    async selectedGroup(v) {
      this.search = '';
      await this.refresh();
    },
  },
  computed: {
    computedGroups() {
      if (!this.groups) return [];

      return this.groups.map((g) => {
        return {
          value: g,
          text: g.name,
        }
      });
    },
    searchedOrderFormItems () {
      let searched = this.orderFormItems.filter((orderFormItem) => {
        let include = false;
        // search name
        include ||= orderFormItem.naziv_artikla2?.toLowerCase().includes(this.search.toLowerCase());
        // search id
        include ||= orderFormItem.id?.toString().includes(this.search.toLowerCase());

        return include;
      });

      if (this.showOrdered) {
        const headers = this.fields.filter((h) => h.key.startsWith('kol_')).map((h) => h.key)
        searched = searched.filter((item) => headers.some((key) => item[key] > 0));
      }

      return searched;
    },
  },
  async created() {
    this.$store.commit('loader/START_LOADING');

    await axios.get('/admin/getAdminInfo').then(response => {
        this.status = response.data.status;
        this.deadline.value = response.data.order_deadline;
    }).finally(() => this.$store.commit('loader/END_LOADING'));

    this.$store.commit('loader/START_LOADING');

    await axios.get(`/admin/groups`)
      .then((response) => {
        this.groups = response.data
      })
      .finally(() => this.$store.commit('loader/END_LOADING'));

  },
  methods: {
    async saveNote() {
      this.$store.commit('loader/START_LOADING');

      await axios.patch(`/admin/orderForms/${this.orderFormId}`, { adminNote: this.note })
        .then(() => toast('Uspešno snimanje napomene.', variants.SUCCESS))
        .finally(() => this.$store.commit('loader/END_LOADING'));
    },
    async refresh() {
      if (!this.selectedGroup) return;
      
      this.$store.commit('loader/START_LOADING');
      try {
        await axios.get(`/admin/orderForms/partner/${this.selectedGroup.id}`).then(response => {
          if (response.data.order_forms.length == 0) {
            this.orderFormItems = [];
            return;
          }

          this.note = response.data.order_forms[0].admin_note;
          this.orderFormId = response.data.order_forms[0].id;
          this.orderFormItems = [...response.data.order_forms[0].items];
          const headers = [];
          for (const orderForm of response.data.order_forms) {
            const key = 'kol_' + orderForm.id;
            for (const item of orderForm.items) {
              const found = this.orderFormItems.find(i => i.id === item.id);
                if (found) {
                found[key] = item.kol;
              }
            }
            headers.push({
              key, 
              label: orderForm.object_name, 
              sortable: false,
              showTooltip: !!orderForm.employee_note,
              tooltipText: `${orderForm.employee_note}` // You can customize this text
            });          
          }

          this.fields = [...this.initialFields, ...headers];
        })

        await axios.get('/admin/getAdminInfo').then(response => {
          this.status = response.data.status;
        })

      } catch (e) {
        // eslint-disable-next-line no-empty
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    async sendOrderForm() {
      await this.setStatus('SOFT_ORDERED');
    },
    async setStatus(status) {
      this.$store.commit('loader/START_LOADING');
      try {
        const response = await axios.put(`/admin/setStatus`, { status: status });

        if (response.status == 200) {
          toast('Uspešno izmena statusa.', variants.SUCCESS)
          this.status = status;
        }

      } catch (e) {
        // eslint-disable-next-line no-empty
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    async downloadOrderFormSummary() {
      this.$store.commit('loader/START_LOADING');
      
      try {
        const response = await axios.get(`/admin/orderForms/summary/export`, {
          responseType: 'blob',
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'analiza_porudžbenica.xlsx');
        document.body.appendChild(link);
        link.click();
        toast('Uspešno preuzimanje analize porudžbenica.', variants.SUCCESS)
      } catch (e) {
        // eslint-disable-next-line no-empty
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    async setDeadline() {
      if (!this.deadline.value || new Date(this.deadline.value) < new Date()) {
        this.deadline.error = true;
        this.deadline.errorMessage = 'Krajnji rok ne može biti u prošlosti.';
        return;
      }
      this.$store.commit('loader/START_LOADING');
      try {
        await axios.put(`/admin/order-deadline`, { order_deadline: this.deadline.value }).then(() => {
          toast('Uspešno izmenjen krajnji rok.', variants.SUCCESS)
        });
      } catch (e) {
        // eslint-disable-next-line no-empty
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    async downloadOrderFormItems() {
      if (!this.selectedGroup) return;

      this.$store.commit('loader/START_LOADING');
      
      try {
        const response = await axios.get(`/admin/orderForms/withGroup/export/${this.selectedGroup.id}`, {
          responseType: 'blob',
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'porudžbenice.xlsx');
        document.body.appendChild(link);
        link.click();
        toast('Uspešno preuzimanje porudžbenice.', variants.SUCCESS)
      } catch (e) {
        // eslint-disable-next-line no-empty
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title"/>
    <div class="row mb-2">
      <div class="col-md-6 col-12">
        <label class="col-form-label mr-2" for="groups">Grupa:</label>
        <b-form-select id="groups" v-model="selectedGroup" :options="computedGroups">
          <template #first>
            <b-form-select-option :value="null" disabled>-- Izaberi grupu --</b-form-select-option>
          </template>
        </b-form-select>
        <!-- <VueBootstrapAutocomplete
          class="autocomplete"
          id="groups"
          :data="groups"
          :serializer="(item) => item.name"
          :minMatchingChars="0"
          showOnFocus
          @hit="selectedGroup = $event"
        /> -->
      </div>
      <div class="col-md-6 col-12 text-right">        
        <b-button class="mr-2 mt-2" :disabled="!selectedGroup" type="button" variant="success" @click="saveNote()">Snimi napomenu</b-button>
        <b-dropdown right :variant="this.status === 'ALLOW_ORDERING' ? 'success': 'danger'" size="md" class="mr-2 mt-2">
          <template slot="button-content">
              Status: <span style="text-transform: capitalize">{{ this.statuses.find(s => s.key == this.status) ?  this.statuses.find(s => s.key == this.status).value: '' }}</span>
          </template>
          <b-dropdown-item-button  v-for="s of statuses" v-bind:key="s.key" :disabled="status === 'SOFT_ORDERED' || s.key=='SOFT_ORDERED'" @click="setStatus(s.key)">{{ s.value }}</b-dropdown-item-button>
        </b-dropdown>
        <b-dropdown right variant="primary" size="md" class="mt-2">
          <template slot="button-content">
            <i class="fas fa-file-download mr-1"></i>
            Preuzmi
            <i class="mdi mdi-chevron-down"></i>
          </template>
          <b-dropdown-item :disabled="!selectedGroup" @click="downloadOrderFormItems()">Porudžbenice - Excel</b-dropdown-item>
          <b-dropdown-item @click="downloadOrderFormSummary()">Analiza Porudžbenica - Excel</b-dropdown-item>
        </b-dropdown>
        <confirmation-modal buttonClass="mt-2" v-if="status !== 'SOFT_ORDERED'" :disabled="status === 'SOFT_ORDERED'" variant="warning" message="Da li ste sigurni da želite da pošaljete porudžbenicu?" title="Pošalji Porudžbenicu" buttonText="Pošalji porudžbenicu" @onSubmit="sendOrderForm" @closed="refresh" />
      </div>
    </div>

    <div class="row mb-2">
      <div class="col-md-6 col-12">
        <label for="textarea">Napomena: </label>
        <b-form-textarea
          id="textarea"
          v-model="note"
          rows="3"
          max-rows="3"
        ></b-form-textarea>
      </div>
      <div class="col-12 col-md-6 text-right justify-content-end">
        <b-button variant="secondary" @click="refresh()" :disabled="!this.selectedGroup">
          Osveži
          <i class="mdi mdi-refresh"></i>
        </b-button>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-9 d-flex align-items-center">
        <label class="col-form-label mr-2" for="input-1">Krajnji rok:</label>
          <b-form-input
          id="input-1"
          v-model="deadline.value"
          @input="deadline.error = false"
          type="date"
          required
          style="width: 200px"
          :class="{ 'is-invalid': deadline.error , 'ml-2': true}"
        ></b-form-input>
          <button class="btn btn-primary ml-2" @click="setDeadline()" >Snimi</button>
          <b-form-invalid-feedback v-if="deadline.error"
          class="ml-2"
            style="width: 200px"
          >
            {{deadline.errorMessage}}
          </b-form-invalid-feedback>
      </div>
      <div class="col-3 align-items-center justify-content-center d-flex">
        <b-form-checkbox
                v-model="showOrdered"
                :value="true"
                :unchecked-value="false"
                switch
        >
          Prikaži samo poručene artikle
        </b-form-checkbox>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-12">
        <div class="search-box chat-search-box ">
          <div class="position-relative">
            <input v-model="search" type="text" class="form-control" placeholder="Pretraži..."/>
            <i class="bx bx-search-alt search-icon"></i>
            <i class="bx bx-x clear-icon" @click="search = ''"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <b-table :items="searchedOrderFormItems" :fields="fields" striped responsive
                 class="border-left border-right border-bottom"
        >
          <template v-for="field in fields" v-slot:[`head(${field.key})`]>
            <span :key="`tooltip-${field.key}`" v-if="field.key.startsWith('kol_') && field.showTooltip" class="d-flex align-items-center">
              {{ field.label }}
              <i 
                class="fas fa-info-circle ml-1" 
                v-b-tooltip.hover.right 
                :title="field.tooltipText"
              ></i>
            </span>
            <span :key="`regular-${field.key}`" v-else-if="field.key.startsWith('kol_')">
              {{ field.label }}
            </span>
          </template>
        </b-table>

      </div>
    </div>
  </Layout>
</template>

<style scoped>
  .search-box .form-control {
    border-radius: 0.25rem;
  }
  
  /* Add these new styles */
  .fa-info-circle {
    opacity: 0.8;
  }
  .fa-info-circle:hover {
    opacity: 1;
  }
</style>
